<template>
  <div class="modal-overlay" @click.self="modalStore.closeAllModals()">
    <div class="modal-window">
      <div class="modal-content">
        <div class="modal-text-container">
          <h2 class="modal-title">Логин</h2>

          <!-- 📞 Телефон -->
          <PhoneInput
            v-model="phone"
            :disabled="isLoading"
            @valid="isPhoneValid = $event"
            placeholder="+7 900 000-00-00"
          />

          <!-- 🔑 Пароль -->
          <input
            v-model="password"
            class="modal-input"
            type="password"
            placeholder="Пароль"
            :disabled="isLoading"
            @keyup.enter="login"
          />

          <!-- ▶ Кнопка входа -->
          <button
            class="button-1"
            @click="login"
            :disabled="isLoading || !isFormValid"
            :class="{ loading: isLoading }"
          >
            <span>{{ isLoading ? "Входим..." : "Войти" }}</span>
          </button>

          <!-- 🔁 Восстановление -->
          <button
            v-if="showRestoreButton"
            class="button-1 button-restore"
            @click="restorePassword"
            :disabled="isLoading"
          >
            <span>Восстановить пароль</span>
          </button>

          <!-- 🔔 Уведомление -->
          <div v-if="notification" class="modal-toast">
            {{ notification }}
          </div>
        </div>
      </div>

      <button class="modal-close" @click="close()">✖</button>
    </div>
  </div>
</template>

<script>
import PhoneInput from "@/components/modals/PhoneInput.vue";
import { useAuthStore } from "@/stores/auth";
import { useModalStore } from "@/stores/modals";
import { useReCaptcha } from "vue-recaptcha-v3";

export default {
  name: "LoginModal",

  components: {
    PhoneInput,
  },

  emits: ["logged-in"],

  setup() {
    const authStore = useAuthStore();
    const modalStore = useModalStore();
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

    return {
      authStore,
      modalStore,
      executeRecaptcha,
      recaptchaLoaded,
    };
  },

  data() {
    return {
      phone: "", // ← всегда "+7916..."
      isPhoneValid: false,
      password: "",
      notification: "",
      showRestoreButton: false,
      isLoading: false,
      notifyTimer: null,
    };
  },

  computed: {
    isFormValid() {
      return this.isPhoneValid && this.password.length > 0;
    },
  },

  methods: {
    showToast(message, duration = 3000) {
      this.notification = message;
      clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(() => {
        this.notification = "";
      }, duration);
    },

    async login() {
      if (this.isLoading || !this.isFormValid) return;

      this.isLoading = true;
      this.showRestoreButton = false;

      try {
        await this.recaptchaLoaded();
        const recaptchaToken = await this.executeRecaptcha("login");

        const formData = new FormData();
        formData.append("phone", this.phone); // ← УЖЕ нормализован
        formData.append("password", this.password);
        formData.append("recaptcha_token", recaptchaToken);

        const res = await fetch("https://dancerus.ru/api/login.php", {
          method: "POST",
          body: formData,
        });

        const data = await res.json();

        if (data.status === "success" && data.token) {
          this.authStore.setToken(data.token);
          this.showToast("Вы успешно вошли!", 2000);
          this.$emit("logged-in", data.token);

          setTimeout(() => {
            this.modalStore.closeLoginModal();
          }, 1500);
        } else {
          this.showToast(data.message || "Ошибка входа");
          this.showRestoreButton = data.message?.includes("пароль") || false;
        }
      } catch (err) {
        console.error(err);
        this.showToast("Ошибка сети или reCAPTCHA");
      } finally {
        this.isLoading = false;
      }
    },

    restorePassword() {
      if (!this.isPhoneValid) {
        this.showToast("Введите корректный номер телефона");
        return;
      }

      this.modalStore.openResetPasswordModal();
      this.showRestoreButton = false;
      this.notification = "";
    },

    close() {
      this.showRestoreButton = false;
      this.notification = "";
      this.modalStore.closeLoginModal();
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/mixins.scss";
</style>
